import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {TreeSelect} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(TreeSelect, {
        'data': this.get('data'),
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value')
    });
};